import BaseService from '../BaseService';

class PrestadoresService extends BaseService {
    constructor() {
        super('/pessoas/prestadores/');
    }
}

export default new PrestadoresService();
